const backendUrl = import.meta.env.VITE_APP_BACKEND_HOST

const iframePreview = ({
  widget,
  offer,
  flow,
  load = true,
  splitTestVariantId,
  splitTestFlowId
}: {
  widget: object | boolean
  offer?: object
  flow?: object
  load?: boolean
  splitTestVariantId?: string
  splitTestFlowId?: string
}) => {
  const configStore = useConfigStore()
  const { currentTeamPid } = storeToRefs(configStore)
  const widgetStore = useWidgetStore()

  let widgetId = 'wdg_default'

  if (widget !== false) {
    if (!widget && offer) {
      widget = widgetStore.getWidgetsForOffer(offer.id)[0]
    }

    if (!widget) {
      widget = widgetStore.widgets[0]
    }

    if (widget) widgetId = widget.id
  }

  let url = `${backendUrl}/_/${currentTeamPid.value}/preview/${widgetId || 'wdg_default'}?nodeId=${
    offer?.id || ''
  }&flowId=${flow?.id || ''}&iframe=true&removeZoom=1${!load ? '&skipload=true' : ''}`

  // Append split test variant params for flow A/B test previews
  if (splitTestVariantId && splitTestFlowId) {
    url += `&splitTestVariantId=${encodeURIComponent(splitTestVariantId)}&splitTestFlowId=${encodeURIComponent(splitTestFlowId)}`
  }

  return url
}

export default iframePreview
